/*
  Size pills on Virasat product cards (snippets/virasat-product-card.liquid).
  Picking a size updates the variant the card adds to the cart, the price, and
  the button when that size is sold out. One listener handles every card on the page.
*/
document.addEventListener('click', (event) => {
  const pill = event.target instanceof Element ? event.target.closest('.v-card__size') : null;
  if (!pill) return;

  const card = pill.closest('.v-card');
  if (!card) return;

  card.querySelectorAll('.v-card__size').forEach((other) => {
    other.setAttribute('aria-pressed', other === pill ? 'true' : 'false');
  });

  const available = pill.dataset.available === 'true';
  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.value = pill.dataset.variantId;
    variantInput.disabled = !available;
  }

  const price = card.querySelector('[data-card-price]');
  if (price) price.textContent = pill.dataset.price;

  const button = card.querySelector('.v-card__add');
  if (button) {
    button.disabled = !available;
    const label = [...button.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (label) label.textContent = available ? card.dataset.addLabel : card.dataset.soldOutLabel;
  }
});
